export class StrainMeasurementGageValuesModel {
    public name: string;
    public unit: string;
    public min: string;
    public max: string;

    constructor(entry: any = {}) {
        this.name = entry.name ? entry.name : "";
        this.unit = entry.unit ? entry.unit : "";
        this.min = entry.min ? entry.min : "";
        this.max = entry.max ? entry.max : "";
    }
}
